export const meetingAgendaConstants = {
  API_BASE_PATH: 'v1/meeting_registers/:meeting_register_id/meeting_agendas',
  GET_MEETING_AGENDAS: 'GET_MEETING_AGENDAS',
  SET_MEETING_AGENDAS_LOADING: 'SET_MEETING_AGENDAS_LOADING',
  SET_MEETING_AGENDAS_ERROR: 'SET_MEETING_AGENDAS_ERROR',
};
